import { AddAddress } from "./components/myaccount/address";

function AddAddressBook() {
    return (
        <>
            <AddAddress />
        </>
    );
}

export default AddAddressBook;